import request from "@/router/axios"
export const syncApi = () => {
    return request({
        url: `/api/sys/apiInfo/syncApi`,
        method: 'get',
    })
}
export const list = (query) => {
    return request({
        url: `/api/sys/apiInfo/list`,
        method: 'post',
        data: query
    })
}
export const getPermission = (appCode) => {
    return request({
        url: `/api/sys/apiInfo/getPermission`,
        method: 'get',
        params: {
            appCode
        }
    })
}
export const setPermission = (appCode, apiIds) => {
    return request({
        url: `/api/sys/apiInfo/setPermission`,
        method: 'post',
        params: {
            appCode,
            apiIds
        }
    })
}